import { Box, Flex, Image, Text, VStack, HStack, Link, Heading, } from "@chakra-ui/react"; 

export default function PreFooter() {
     return (
         <Box bg="gray.800" py={{ base: 10, md: 16 }} px={{ base: 6, md: 12 }} color="white"> 
            <Flex maxW="1200px" mx="auto" justify="space-between" 
                direction={{ base: "column", md: "row" }} gap={{ base: 8, md: 12 }} > 
                
                {/* LEFT SIDE — LOGO + NAME */} 
                <HStack spacing={4} justify={{ base: "center", md: "flex-start" }}> 
                    <Image src={require('../images/logo.png')} alt="SwiftChang Logo" boxSize={{ base: "40px", md: "48px" }} style={{ mixBlendMode: 'lighten' }} /> 
                    <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold"> SwiftChang </Text> 
                </HStack> 
                    
                {/* RIGHT SIDE — NAVIGATION COLUMNS */} 
                <Flex
                    gap={{ base: 6, md: 20 }}
                    wrap={{ base: "nowrap", md: "wrap" }}
                    direction={{ base: "column", md: "row" }}
                    align={{ base: "center", md: "stretch" }}
                    justify={{ base: "center", md: "flex-end" }}
                    textAlign={{ base: "center", md: "left" }}
                > 
                    
                    {/* PRODUCTS */} 
                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}> 
                        <Heading size="sm">Products</Heading> 
                        <Link href="/money-transfer">International Transfers</Link> 
                        <Link href="/money-transfer#multi-currency">Multi-currency Wallet</Link> 
                        <Link href="/money-transfer#currency-swap">Currency Swap</Link> </VStack> 
                    
                    {/* COMPANY */}
                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Heading size="sm">Company</Heading>
                        <Link href="/about">About SwiftChang</Link>
                        <Link href="/promotions">Promotions</Link>
                        <Link href="/community">Refer and Earn</Link>
                        <Link href="/influencer">Become our Influencer</Link>
                        {/*<Link href="#">Careers</Link> */}
                    </VStack>

                    {/* RESOURCES */}
                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Heading size="sm">Resources</Heading>
                        <Link href="/help">Help</Link>
                        <Link href="/blog">Blog</Link>
                    </VStack>
                    
                    {/* RESOURCES */} 
                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}> 
                        <Heading size="sm">Legal</Heading> 
                        <Link href="/terms-of-service">Terms of Service</Link> 
                        <Link href="/privacy-policy">Privacy Policy</Link> 
                    </VStack> 
                </Flex> 
            </Flex> 
        </Box> ); }